import React from 'react';
import { InfoCircle } from '@saleshandy/icons';

import Checkbox from '../../../design-system/components/atoms/checkbox';
import {
  OverlayTooltip,
  Placement,
} from '../../../design-system/components/overlay';

type IProps = {
  scheduleConditionChecked: boolean;
  setScheduleConditionChecked: (checked: boolean) => void;
};

const ScheduleCondition: React.FC<IProps> = ({
  scheduleConditionChecked,
  setScheduleConditionChecked,
}) => (
  <div className="schedule-reply-modal--content-wrapper schedule-condition-wrapper">
    <div className="schedule-condition-header">
      <p className="schedule-reply-modal--content-label">Schedule Condition</p>
      <OverlayTooltip
        className="schedule-condition-tooltip"
        placement={Placement.Right}
        text="If prospect replies before scheduled time, the email will not be sent & saved as draft. Incase you still want to send it, enable the below checkbox."
      >
        <InfoCircle />
      </OverlayTooltip>
    </div>

    <Checkbox
      checked={scheduleConditionChecked}
      onChange={(checked: boolean) => setScheduleConditionChecked(checked)}
      label="Send email as scheduled, even if prospect replies to this thread."
    />
  </div>
);

export default ScheduleCondition;
